import { useDisclosure } from '@mantine/hooks'
import { useFacadeGlassesEntriesQuery } from '@/features/facade/FacadeGlass/store'
import useStyles from './Style.styles'
import { WindowSettingsModal } from './WindowSettingsModal'

export const Window = (params: any) => {
  const { classes } = useStyles()

  const [opened, { open, close }] = useDisclosure(false)

  const { data, onUpdateWindow, floorId, showActions, scale } = params

  const { data: glazingData } = useFacadeGlassesEntriesQuery({
    params: {
      limit: 0,
    },
  })

  const handleUpdateWindow = (updatedWindow: any) => {
    onUpdateWindow(floorId, data.id, updatedWindow)
  }

  const getColor = () => {
    const currentGlazingType = glazingData?.data?.find((item: any) => item?.id === data?.typeId)

    return currentGlazingType?.color || '#b3e6ff'
  }

  const windowStyles = () => {
    if (!data.width) return {}

    return {
      width: data.width,
      flex: `0 0 ${(data.width / 10) * scale}px`,
      backgroundColor: getColor(),
    }
  }

  return (
    <>
      {data.leftPertition && (
        <div
          className={classes.windowPertition}
          style={{ width: (data.leftPertition.width / 10) * scale }}
        ></div>
      )}
      <div
        className={`${classes.window} ${classes.leftPertition}
          ${!data.leftPertition || data.leftPertition.width === 0 ? classes.leftPertition : ''}
          ${!data.rightPertition || data.rightPertition.width === 0 ? classes.rightPertition : ''}`}
        style={windowStyles()}
      >
        {showActions && (
          <WindowSettingsModal
            data={data}
            opened={opened}
            open={open}
            close={close}
            submit={handleUpdateWindow}
            glazingData={glazingData}
          />
        )}
      </div>
      {data.rightPertition && (
        <div
          className={classes.windowPertition}
          style={{ width: (data.rightPertition.width / 10) * scale }}
        ></div>
      )}
    </>
  )
}
